import React, { useState, useEffect } from 'react';
import "./App.css";
import { Grid } from '@mui/material';
import { VectorMap } from '@react-jvectormap/core';
import { worldMill } from '@react-jvectormap/world';
import { northAmericaMill } from '@react-jvectormap/northamerica';

const API_URL = '/api/visitors';

function App() {
  const [data, setData] = useState([]);
  useEffect(() =>{
    const fetchData = async () => {
      try
      {
        const result = await fetch(API_URL);
        const visitors = await result.json();
        console.log('Total visitors:', visitors.length);
        setData(visitors);
      }catch(error){
        console.error('Fetch error:', error);
      }
      setTimeout(() => { fetchData(); }, 30000);
    };
    fetchData();
  }, []);

  const [time, setTime] = useState(null);
  function refreshTime(){
    setTime(new Date().getUTCHours().toString().padStart(2, '0') + ":" + new Date().getUTCMinutes().toString().padStart(2, '0') + "." + new Date().getUTCSeconds().toString().padStart(2, '0') + "UTC")
  }

  setInterval(() => { refreshTime(); }, 1000);

  function GetIcon(siteId){
    if(siteId === 3) return '/images/F.svg'; // fchapleau
    if(siteId === 4) return '/images/Y.svg'; // byrnu
    return '/images/Y.svg'; // default fallback
  }

  function GetColor(siteId){
    if(siteId === 3) return '#00ff00'; // fchapleau - green
    if(siteId === 4) return '#ff0000'; // byrnu - red
    return '#ffd93d'; // default yellow
  }
  
  return (
    <div className="App">      
      <Grid container className='App-Body'>
        <div className='App-Time'>{time}</div>
            <>
            <div className='App-Main-Container'>
            {data.length > 0 && (
            <VectorMap 
                key={data.length}
                regionStyle={{
                  initial: {
                    fill: 'grey',
                    stroke: "#676767",
                    strokeWidth: 2.5,
                    fillOpacity: 1
                  }
                }}
                normalizeFunction={'polynomial'}
                backgroundColor= {'black'}
                map={northAmericaMill}
                zoomOnScroll={false}
                focusOn={{
                  x: 0.5,
                  y: 0.75,
                  scale: 2,
                  animate: false
                }}
                markerStyle={{
                  initial: {
                    image: '/images/Y.svg'
                  }
                }}
                markers={
                  data.map(element => ({ 
                      latLng: [element.latitude, element.longitude], 
                      name: element.location,
                      style: {
                        image: GetIcon(element.idSite)
                      }
                    }))
                }
            />
            )}
            </div>
            <div className='App-Quebec-Container'>
            {data.length > 0 && (
              <VectorMap 
                  regionStyle={{
                    initial: {
                      fill: 'grey',
                      stroke: "#676767",
                      strokeWidth: 2.5,
                      fillOpacity: 1
                    }
                  }}
                  normalizeFunction={'polynomial'}
                  backgroundColor= {'black'}
                  map={northAmericaMill}
                  zoomOnScroll={false}
                  focusOn={{
                    x: 0.65,
                    y: 0.52,
                    scale: 4,
                    animate: false
                  }}
                  markerStyle={{
                    initial: {
                      image: '/images/Y.svg'
                    }
                  }}
                  markers={
                    data.map(element => ({ 
                        latLng: [element.latitude, element.longitude], 
                        name: element.location,
                        style: {
                          image: GetIcon(element.idSite)
                        }
                      }))
                  }
              />
            )}
            </div>
            <div className='App-Zoom-Container'>
            {data.length > 0 && (
              <VectorMap 
                  regionStyle={{
                    initial: {
                      fill: 'grey',
                      stroke: "#676767",
                      strokeWidth: 2.5,
                      fillOpacity: 1
                    }
                  }}
                  normalizeFunction={'polynomial'}
                  backgroundColor= {'black'}
                  map={worldMill}
                  zoomOnScroll={false}
                  markerStyle={{
                    initial: {
                      r: 4,
                      fill: '#ffd93d',
                      stroke: '#676767',
                      strokeWidth: 1,
                      fillOpacity: 0.9
                    }
                  }}
                  markers={
                    data.map(element => ({ 
                        latLng: [element.latitude, element.longitude], 
                        name: element.location,
                        style: {
                          fill: GetColor(element.idSite),
                          r: 4
                        }
                      }))
                  }
              />
            )}
            </div>
            </>
      </Grid>
    </div>
  );
}

export default App;